var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 32,
    fill: "none",
    viewBox: "0 0 30 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6CBC2E",
    d: "m9.723 15.64 4.069 5.668c.158.226.158.43 0 .59l-7.053 9.997c-.159.204-.52.09-.453-.16l2.985-16.027c.09-.159.293-.226.452-.068m19.442-6.71c.203 0 .294.295.045.453l-8.184 3.582c-.135.09-.293 0-.293-.159l-.679-3.581c0-.136.09-.295.249-.295zM18.9 9.066l4.296 22.58c0 .226-.294.407-.453.158L10.017 13.849c-.136-.159-.385-.385-.588-.453L.115 9.36c-.204-.068-.113-.454.09-.454h18.448c.09 0 .248.068.248.159m-8.274-2.743c-.588.158-.656 0-.226-.408l1.198-.884-.452-2.38c0-.137.09-.227.158-.295L14.787.043c.135-.068.294-.068.384.09l1.967 2.948 1.695.159c.61.09.656.294.068.453z"
  })));
};
export default SvgLogo;